import { render } from "./ReCaptchaComponent.vue?vue&type=template&id=3def425d"
import script from "./ReCaptchaComponent.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ReCaptchaComponent.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__